<template>

<b-row class="payment-step transfer-step">
  <transition name="fade">
    <div v-if="!isLoading">
      <b-col cols="12 order-info-container">
        <div class="f-box-title">
          Order summary
          <p>Order Number: #{{ paymentInfo.orderId }} </p>
        </div>
        <table class="table-descktop">
          <tbody>
            <tr class="with-border">
              <th>Item/Details</th>
              <th>Price</th>
            </tr>
            <tr class="with-border">
              <td>
                {{ (orderData.amount / orderData.asset.price.value).toFixed(6) }} {{ orderData.asset.name }}
                <p class="grey-text">{{ orderData.asset.name }} rate: {{ orderData.asset.price.value.toFixed(2) }}</p>
                <span class="grey-text">Not final.</span>
              </td>
              <td class="text-to-top">{{ parseFloat(orderData.amount).toFixed(2) }} {{ currentOrder.moneyCurrency }}</td>
            </tr>
            <tr>
              <td>Service fee</td>
              <td>{{ paymentInfo.serviceFee }} {{ currentOrder.moneyCurrency }}</td>
            </tr>
            <tr class="with-border">
              <td>Payment method fee</td>
              <td>{{ paymentInfo.paymentMethodFee }} {{ currentOrder.moneyCurrency }}</td>
            </tr>
            <tr class="with-border">
              <td>
                Transfer Funds
              </td>
              <td>
                <p class="tr-p">Please transfer us exactly
                  <b>{{ finalTotal }} {{ currentOrder.moneyCurrency }}</b><br>
                  using the following information:
                </p>

                <span class="bp font-14">BENIFICIARY:  {{ paymentInfo.beneficiary }}</span>
                <span class="bp font-14">BANK NAME:  {{ paymentInfo.name }}</span>
                <span class="bp font-14">BANK ACCOUNT NUMBER: {{ paymentInfo.accountNumber }}</span>
                <span class="bp font-14">BANK ADDRESS: {{ paymentInfo.address }}</span>
                <span class="bp font-14">SWIFT: {{ paymentInfo.swift }}</span>
                <span class="bp font-14">IBAN: {{ paymentInfo.iban }}</span>
              </td>
            </tr>
            <tr>
              <td class="payment-total o-number">PAYMENT TOTAL:</td>
              <td class="o-number">{{ finalTotal }} {{ currentOrder.moneyCurrency }}</td>
            </tr>
          </tbody>
        </table>

        <div class="table-mobile">
          <table>
            <tbody>
              <tr class="with-border">
                <th>Order Number</th>
                <th>Item/Details</th>
              </tr>
              <tr class="with-border">
                <td class="o-number">#{{ paymentInfo.orderId }}</td>
                <td>{{ paymentInfo.item }} {{ paymentInfo.currencyToBuy }}
                  <br>Not final.
                </td>
              </tr>
            </tbody>
            <tr class="with-border">
              <th>Payment Method</th>
              <th>Price</th>
            </tr>
            <tr class="with-border">
              <!-- <td class="">{{ paymentMethod() }}</td> -->
              <td>{{ paymentInfo.price }} {{ currentOrder.moneyCurrency }}</td>
            </tr>
            <tr class="small-padding">
              <td class="">Payment method fee</td>
              <td>{{ paymentInfo.paymentMethodFee }} {{ currentOrder.moneyCurrency }}</td>
            </tr>
            <tr class="with-border">
              <td>Transfer Funds</td>
              <td>
                <p class="tr-p">Please transfer us exactly
                  <b>{{ paymentInfo.finalPayment }} {{ currentOrder.moneyCurrency }}</b><br>
                  using the following information:
                </p>

                <span class="bp font-14">BENIFICIARY:  {{ paymentInfo.beneficiary }}</span>
                <span class="bp font-14">BANK NAME:  {{ paymentInfo.name }}</span>
                <span class="bp font-14">BANK ACCOUNT NUMBER: {{ paymentInfo.accountNumber }}</span>
                <span class="bp font-14">BANK ADDRESS: {{ paymentInfo.address }}</span>
                <span class="bp font-14">SWIFT: {{ paymentInfo.swift }}</span>
                <span class="bp font-14">IBAN: {{ paymentInfo.iban }}</span>
              </td>
            </tr>
            <tr class="small-padding">
              <td class=" o-number">Payment Total</td>
              <td class="o-number">{{ paymentInfo.finalPayment }} {{ currentOrder.moneyCurrency }}</td>
            </tr>
            <!-- </tbody> -->
          </table>
        </div>
      </b-col>
      
      <b-col cols="12">
        <e-hint title="IMPORTANT:" style="margin-top: 20px">
          When creating the bank transfer, please add the Order Number as a comment to the transfer.
          <a href="#" @click.prevent="sendToMail">Send me these instructions to my email</a>
        </e-hint>

        <div class="modal-block-title">Your {{ orderData.asset.name }} wallet ID</div>    
        <div class="buy-wallet-id">{{ orderData.walletId }}</div>
      </b-col>

      <b-col cols="12">
        <div class="modal-block-title">Order Number: #{{ paymentInfo.orderId }}</div>
        <p class="p-info">
          Once you have transfered the money, please keep the transfers reference number and confirm your bank transfer
        </p>

        <e-button @click="nextPage" style="margin-left: auto">I Have Sent Funds to Economix</e-button>    
      </b-col>
    </div>
  </transition>
  <div class="payment-loading" v-if="isLoading">
    Loading ...
  </div>
</b-row>


</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
export default {
  name: "step-wiretransfer",
  components: { },
  data() {
    return {
      // paymentInfo: {},
      // currentOrder: {}
      isLoading: true,
    };
  },
  methods: {
     ...mapActions("settings", ["setPaymentState"]),
     ...mapActions("orders", ["getPaymentInfo", "createOrder"]),
    orderPrice() {
      return 50;
    },
    nextPage() {
      this.$emit('nextPage');
    },
    sendToMail() {

    }
  },
   computed: {
    ...mapGetters("orders", {
      currentOrder: "currentOrder", 
      paymentInfo: "paymentInfo",
      orderData: 'buyModalData'
    }),
    currency_name() {
      if(this.upd) return "Bitcoin"
      return "Bitcоin"
    },
    finalTotal() {
      return parseFloat(this.orderData.amount) + parseFloat(this.paymentInfo.paymentMethodFee) + parseFloat(this.paymentInfo.serviceFee)
    }
  },
  async mounted() {
    this.isLoading = true;
    console.log(this.orderData);
    await this.createOrder({
      coin: { 
        amount: this.orderData.amount, 
        symbol: this.orderData.asset.symbol 
      }, 
      currency: this.orderData.currency
    });

    await this.getPaymentInfo();
    console.log(this.paymentInfo);
    this.isLoading = false;
    // setInterval(() => { this.upd = !this.upd; }, 200)
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/modals/buyCrypto/stepWiretransfer.vue